import "leaflet/dist/leaflet.css";
import "react-phone-input-2/lib/style.css";
import "react-quill-new/dist/quill.snow.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-loading-skeleton/dist/skeleton.css';
import "react-datepicker/dist/react-datepicker.css";
import "./_CORE/APP/Templates/_Styles/_AppStylesImported.css";
import "./Web/_UI/_Styles/PortfolioShellTheme.css";
import "./Web/Views/Private/_Shared/_UI/_Styles/PortfolioAdmin.css";

import { AppErrorBoundary } from "./_CORE/APP/Hooks/Contexts/_Auth/_App/_index";
import { AppRouting } from "./_CORE/APP/Routing/AppRouting";
import { AppProviders } from "./_CORE/APP/Hooks/Contexts/_AppProviders";
import { AppTemplateResolved } from "./_CORE/APP/Templates/AppTemplateResolved";
import { APP_ENVIRONMENT } from './_CORE/_Config/_ENV/AppEnvironment';
import { AppConfirmHost } from "./_CORE/APP/Templates/_UI/Confirm/AppConfirmHost";
import { AppAlertHost } from "./_CORE/APP/Templates/_UI/Alerts/AppAlertHost";
import "./Web/_UI/_Styles/MonochromeDark.css";
import "./Web/_UI/_Styles/PolishAdjustments.css";
import "./Web/Views/Public/_Auth/Components/_Styles/AuthMinimal.css";

function App() {

    return (
        <AppErrorBoundary isDetailed={APP_ENVIRONMENT.APP__IS_NODE_ENV}>
            <AppTemplateResolved>
                <AppProviders>
                    <AppRouting />
                    <AppConfirmHost />
                    <AppAlertHost />
                </AppProviders>
            </AppTemplateResolved>
        </AppErrorBoundary>
    );
}

export default App;
